import boxes from "./components/boxes";
import buttons from "./components/buttons";
import cards from "./components/cards";
import images from "./components/images";
import layout from "./components/layout";
import links from "./components/links";
import styles from "./primitives"; // Base

var theme = {
  useBorderBox: true,
  colors: {
    text: "#fff",
    background: "#202020",
    primary: "#4d998a",
    secondary: "#fce865",
    accent: "#e6ffec",
    highlight: "#1f4659",
    muted: "#2d7273"
  },
  fonts: {
    body: "sans-serif",
    heading: "sans-serif",
    monospace: "monospace"
  },
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125
  },
  fontSizes: ["12px", "14px", "16px", "20px", "24px", "32px", "48px", "64px", "72px"],
  space: ["0px", "4px", "8px", "16px", "32px", "64px", "128px", "256px", "512px"],
  borderWidths: {
    none: "0px",
    small: "1px",
    medium: "2px",
    large: "3px"
  },
  radii: {
    none: "0px",
    small: "4px",
    medium: "8px",
    large: "16px",
    maximum: "99999px"
  },
  breakpoints: ["640px", "768px", "1024px", "1280px", "1536px"],
  textStyles: {
    heading: {
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
      marginTop: 0,
      marginBottom: 3,
      "&:last-of-type": {
        marginBottom: 0
      }
    }
  },
  // Base styles
  styles: styles,
  // Buttons variants
  buttons: buttons,
  // Images variants
  images: images,
  // Cards variants
  cards: cards,
  // Boxes variants
  boxes: boxes,
  // Links variants
  links: links,
  // Layout variants
  layout: layout
};
export default theme;